export default {
  name: 'append-to-body',
  inserted: function (el) {
    document.body.appendChild(el);
  },
};
